var ctrl = function($scope, ProductImageSrc, $timeout) {
  $scope.imgSrc = function() {
    return ProductImageSrc.imgSrc($scope.productLine, $scope.width, $scope.height)
  };

  $scope.savedImgSrc = $scope.imgSrc();

  $scope.getStyle = function() {
    return {
      'background-image': 'url(' + $scope.savedImgSrc + ')'
    };
  }

  if (!$scope.productLine) {
    $scope.sizeStyle = {
      'width': $scope.width + 'px',
      'height': $scope.height + 'px',
      'background-image': 'url(' + $scope.savedImgSrc + ')',
      'background-size': 'contain'
    };
  } else {
    $scope.sizeStyle = {
      'max-width': $scope.width + 'px',
      'max-height': $scope.height + 'px',
      'background-image:url': $scope.savedImgSrc
    };
  }
};

ctrl.$inject = ['$scope', 'ProductImageSrc', '$timeout'];

tiz.controller('productImageCtrl', ctrl);

var directive = function() {
  return {
    controller: 'productImageCtrl',
    templateUrl: function(el, attrs) {
      if (attrs.imageCanChange) {
        return require('../../templates/product_image/product_image_can_change.html')
      } else {
        return require('../../templates/product_image/product_image.html')
      }
    },
    scope: {
      productLine: '=',
      width: '@',
      height: '@',
      imageCanChange: '='
    }
  };
};

tiz.directive('productImage', directive);
